<template>
    <!-- 总平台管理－票券管理 -->
    <div class="totalplatform-ticket-manage">
        <content-view  v-show="$utils.renderWhen(this,'ticket')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="票券展示名称">
                        <a-input placeholder="请输入" v-decorator="['showName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="票券内部名称">
                        <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="票券类型">
                        <a-select allowClear placeholder="请选择" v-decorator="['type']" @select="search">
                            <a-select-option value="1">期限卡</a-select-option>
                            <a-select-option value="2">次卡</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="票券售卖平台">
                        <a-select allowClear :options="sellPlatform" placeholder="请选择" v-decorator="['sellPlatform']" @select="search"></a-select>
                    </a-form-item>
                    <!-- <a-form-item label="票券售卖门店">
                        <a-select allowClear :options="shopList" placeholder="请选择" v-decorator="['sellShopId']" @select="search"></a-select>
                    </a-form-item> -->
                    <a-form-item label="票券适用门店">
                        <a-select allowClear :options="shopList" placeholder="请选择" v-decorator="['suitShopId']" @select="search"></a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card
            :bordered="false"
            :tabList="tabListNoTitle"
            :activeTabKey="noTitleKey"
            @tabChange="key => onTabChange(key)"
            >
                <a-button slot="tabBarExtraContent" v-if="getBtnByAuth('addTicket')" class="mb16" type="primary" @click="toAddTicket()">新增票券</a-button>
                <a-button slot="tabBarExtraContent" v-if="getBtnByAuth('addTicket')" class="mb16" type="primary" @click="toAddTicket(false)">复制票券</a-button>
                <a-table :scroll="{x:1500, y: 600}" :loading="tableLoading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.ticketTemplateId">
                    <template slot="empty" slot-scope="key">
                        {{key === null ? '--' : key}}
                    </template>
                    <template slot="onShelvesTime" slot-scope="onShelvesTime">
                        {{onShelvesTime || '暂不设置'}}
                    </template>
                    <template slot="offShelvesTime" slot-scope="offShelvesTime">
                        {{offShelvesTime || '暂不设置'}}
                    </template>
                    <template slot="shops" slot-scope="shops">
                        <p v-html="suitShop(shops)"></p>
                    </template>
                    <!-- <template slot="isPointSell" slot-scope="isPointSell">
                        {{['否','是'][Number(isPointSell)]}}
                    </template> -->
                    <template slot="ticketType" slot-scope="key">
                        {{key | ticketType}}
                    </template>
                    <template slot="totalStockNum" slot-scope="key, row">
                        {{row.totalStockNum == "999999999" ? "不限量" : row.totalStockNum}}
                    </template>
                    <template slot="sellPlatform" slot-scope="key, row">
                        {{row | sellPlatform}}
                    </template>
                    <template slot="action" slot-scope="key, row">
                        <div class="action">
                            <template v-if="!row.isOnShelves && getBtnByAuth('updateTicket')">
                                <a @click="toUpdateTicket(row.ticketTemplateId)" class="text-primary">编辑</a>
                                <a-divider type="vertical"></a-divider>
                            </template>
                            <a v-if="getBtnByAuth('detailTicket')" @click="toDetailTicket(row.ticketTemplateId)" class="text-primary">详情</a>
                            <a-divider type="vertical"></a-divider>
                            <a-popconfirm :title="`确认将该“${row.name}”${row.isOnShelves ? '下架' : '上架'}?`" @confirm="ticketState(row.ticketTemplateId, row.isOnShelves)" okText="是" cancelText="否">
                                <a class="text-primary" v-if="getBtnByAuth('updateTicketState')">{{`${row.isOnShelves ? '下架' : '上架'}`}}</a>
                            </a-popconfirm>
                            <template v-if="!row.isOnShelves && getBtnByAuth('removeTicket')">
                                <a-divider type="vertical"></a-divider>
                                <a-popconfirm :title="row.isPointSell ? '该票券在积分商城上架售卖中，是否确认删除？' : '确认将该票券删除?'" @confirm="ticketRemove(row.ticketTemplateId)" okText="是" cancelText="否">
                                    <a class="text-primary">删除</a>
                                </a-popconfirm>
                            </template>
                            <template v-if="!row.isOnShelves && getBtnByAuth('ticketSellTime')">
                                <a-divider type="vertical"></a-divider>
                                <a class="text-primary" @click="openModel(1, row)">售卖时间</a>
                            </template>
                            <template v-if="!row.isOnShelves && row.isCounterSell && getBtnByAuth('ticketCounter')">
                                <a-divider type="vertical"></a-divider>
                                <a class="text-primary" @click="openModel(2, row)">收银台</a>
                            </template>
                            <template v-if="!row.isOnShelves && getBtnByAuth('ticketStore')">
                                <a-divider type="vertical"></a-divider>
                                <a class="text-primary" @click="openModel(3, row)">库存</a>
                            </template>
                        </div>
                    </template>
                </a-table>
            </a-card>
            <a-modal
            centered
            title="库存设置"
            v-model="visibleNum"
            @ok="changeNum"
            @cancel="visibleNum = false"
            :width="600"
            :destroyOnClose="true">
                <a-form :form="reserveForm">
                    <a-form-item label="票券总库存" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                        <a-radio-group allowClear placeholder="请选择" v-decorator="['type',{initialValue: 1}, {rules: [{required: true}]}]">
                            <a-radio :value="1">不限量</a-radio>
                            <a-radio :value="2">限制总库存数</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="reserveForm.getFieldValue('type') == 2" label="票券总库存" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                        <a-input-number :min="0" v-decorator="['stockNum', {rules: [{required: reserveForm.getFieldValue('type') == 2, message: '总库存数不能小于已使用数量'}, {validator: validatorRule}]}]"/>
                    </a-form-item>
                    <a-form-item :colon="false" label=" " :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                        <span>已使用：{{currentRow.totalUsedNum}}</span>
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal
            title="售卖时间设置"
            v-model="visibleTime"
            @ok="changeTime"
            @cancel="visibleTime = false; timeForm.resetFields()"
            :width="800"
            :destroyOnClose="true">
                <a-form :form="timeForm">
                    <a-form-item label="上架时间" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                        <a-radio-group @change="datePickerChange($event, 'enableState')" v-decorator="['enableState', {initialValue: enableState, rules: [{required: true, message: '请输入'}]}]">
                            <a-radio :value="0">暂不设置</a-radio>
                            <a-radio :value="1">设置上架时间</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :required="false" :colon="false" label=" " :label-col="{span: 4}" :wrapper-col="{span: 10}">
                        <a-date-picker :disabled="!Boolean(enableState)" showTime style="width: 350px;" v-decorator="['onShelvesTime', {rules: [{required: Boolean(enableState), message: '请输入'}]}]" placeholder="年-月-日 时:分:秒"/>
                    </a-form-item>
                    <a-form-item label="下架时间" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                        <a-radio-group @change="datePickerChange($event, 'disableState')" v-decorator="['disableState', {initialValue: disableState, rules: [{required: true, message: '请输入'}]}]">
                            <a-radio :value="0">暂不设置</a-radio>
                            <a-radio :value="1">设置下架时间</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :required="false" :colon="false" label=" " :label-col="{span: 4}" :wrapper-col="{span: 18}">
                        <a-date-picker :disabled="!Boolean(disableState)" showTime style="width: 350px;" v-decorator="['offShelvesTime', {rules: [{required: Boolean(disableState), message: '请输入'}]}]" placeholder="年-月-日 时:分:秒"/>
                    </a-form-item>
                    <a-form-item label="不可售卖日期" :label-col="{span: 4}" :wrapper-col="{span: 19}">
                        <div class="flex flex-start">
                            <a-checkbox :indeterminate="NoSellWeeksLimitIndeterminate" :checked="NoSellWeeksLimitCheckAll" @change="NoSellWeeksLimitAllChange">
                                全选
                            </a-checkbox>
                            <a-checkbox-group @change="NoSellWeeksLimitChange" :options="weekData" v-decorator="['NoSellWeeksLimit']"></a-checkbox-group>
                        </div>
                    </a-form-item>
                    <a-row class="mb24">
                        <a-col :span="4"></a-col>
                        <a-col>
                            <a class="text-primary" @click="addExcludeDate()">增加排除日期</a>
                        </a-col>
                    </a-row>
                    <template v-for="(item, index) in excludeDateList">
                        <a-row :key="'excludeDate' + item.key">
                            <a-col span="14">
                                <a-form-item label="排除日期范围" :label-col="{span: 7}" :wrapper-col="{span: 17}">
                                    <a-range-picker style="width: 100%;" v-decorator="[`NoSellDatesLimit[${index}]`, {initialValue: item.value, rules: [{required: true, message: '请输入'}]}]" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="10">
                                <a @click="delExcludeDate(index)" class="text-primary ml16" style="line-height: 32px;">删除</a>
                            </a-col>
                        </a-row>
                    </template>
                </a-form>
            </a-modal>
            <a-modal
            title="售卖收银台设置"
            v-model="visiblePlatform"
            @ok="changePlatform"
            @cancel="visiblePlatform = false"
            :width="800"
            :destroyOnClose="true">
                <a-form :form="platformForm">
                    <a-form-item :label="item.name" :labelCol="{span: 6}" :wrapperCol="{span: 18}" v-for="(item, index) in platformList" :key="index">
                        <a-checkbox-group allowClear placeholder="请选择" v-decorator="[`platform${index}`]">
                            <a-checkbox v-for="(items, index1) in item.platform" :key="index1" :value="items.id">{{items.name}}</a-checkbox>
                        </a-checkbox-group>
                    </a-form-item>
                </a-form>
            </a-modal>
            <ticket-picker tableType="radio" goodType="ticket" ref="ticketPicker" :ticketList="ticketList" @confirmSelectTicket='confirmSelectTicket'></ticket-picker>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import ticketPicker from "@/components/modules/platform/tickets-picker.component";
    const tabListNoTitle = [
        {
            key: '1',
            tab: '上架中',
            columnLine: columns
        },
        {
            key: '0',
            tab: '已下架',
            columnLine: columns
        },
        ]
        const columns = [
        {
            title: "票券id",
            dataIndex: "ticketTemplateId",
            width: 80,
        },
        {
            title: "票券展示名称",
            dataIndex: "showName",
        },
        {
            title: "票券内部名称",
            dataIndex: "name",
        },
        {
            title: "票券类型",
            dataIndex: "type",
            scopedSlots: { customRender: 'ticketType' }
        },
        // {
        //     title: "是否商城售卖",
        //     dataIndex: "isPointSell",
        //     scopedSlots: { customRender: "isPointSell" }
        // },
        // {
        //     title: "售卖总份数",
        //     dataIndex: "totalStockNum",
        //     scopedSlots: { customRender: "totalStockNum" }
        // },
        {
            title: "销量",
            dataIndex: "totalSellNum",
            scopedSlots: { customRender: "empty" }
        },
        // {
        //     title: "关联活动销量",
        //     dataIndex: "activitySellNum",
        //     scopedSlots: { customRender: "empty" }
        // },
        {
            title: "售卖价",
            dataIndex: "sellShowPrice"
        },
        {
            title: "票券售卖平台",
            dataIndex: "isCounterSell",
            scopedSlots: { customRender: "sellPlatform" }
        },
        // {
        //     title: "票券售卖门店",
        //     dataIndex: "sellShops",
        //     scopedSlots: { customRender: "shops" }
        // },
        {
            title: "票券适用门店",
            dataIndex: "suitShops",
            scopedSlots: { customRender: "shops" }
        },
        {
            title: "上架展示时间",
            dataIndex: "onShelvesTime",
            scopedSlots: { customRender: "onShelvesTime" }
        },
        {
            title: "下架时间",
            dataIndex: "offShelvesTime",
            scopedSlots: { customRender: "offShelvesTime" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const weekData = [
        {value: 1, label: '周一'},
        {value: 2, label: '周二'},
        {value: 3, label: '周三'},
        {value: 4, label: '周四'},
        {value: 5, label: '周五'},
        {value: 6, label: '周六'},
        {value: 7, label: '周日'}
    ];
    const sellPlatform = [
        {value: 1, label: '小程序'},
        {value: 2, label: '门店'},
        {value: 3, label: '积分商城'},
        {value: 4, label: '第三方平台'}
    ];
    export default {
        name: "ticket",
        components: {ticketPicker},
        props: {},
        data() {
            return {
                columns,
                weekData,
                sellPlatform,
                tabListNoTitle,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20,
                },
                noTitleKey: '1',
                tableLoading: false,
                visibleNum: false,
                visibleTime: false,
                visiblePlatform: false,
                currentRow: {},
                NoSellWeeksLimitCheckAll: false,
                NoSellWeeksLimitIndeterminate: false,
                disableState: 0,
                excludeDateList: [],
                enableState: 0,
                shopList: [],
                platformList: [],
                ticketList: []
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        filters: {
            suitShop(val) {
                if (val) {
                    return val.replace(/[，,]/g, "<br>，");
                } else {
                    return '-';
                }
            },
            sellPlatform(val) {
                let arr = [];
                val.isMiniSell && arr.push('小程序');
                val.isCounterSell && arr.push('门店');
                val.isPointSell && arr.push('积分商城');
                val.isThirdSell && arr.push('第三方平台');
                val.ticketSellThirdVos && val.ticketSellThirdVos.forEach(e => {
                    arr.push(e.thirdName)
                })
                return arr.length == 0 ? '-' : arr.join('，');
            }
        },
        methods: {
            suitShop(val) {
                if (val) {
                    return val.replace(/\,/g, "<br>");
                } else {
                    return '-';
                }
            },
            validatorRule(rule,value,callback){
                if (value && value < this.currentRow.totalUsedNum) {
                    callback('总库存数不能小于已使用数量')
                } else {
                    callback()
                }
            },
            getPlatform() {
                this.$api.ticketDesk.getPlatform({
                    body: {
                        shopId: this.shopId == -1 ? undefined : this.shopId,
                    }
                }).then( res => {
                    this.shopList.forEach(el => {
                        el.platform = res.filter(item => {
                            return item.shopId == el.id;
                        });
                    });
                    if (this.shopId != -1) {
                        this.platformList = this.shopList.filter(el => el.id == this.shopId);
                    } else {
                        this.platformList = this.shopList;
                    };
                    this.queryTicketSellCounterPage(res);
                });

            },
            queryTicketSellCounterPage() {
                this.$api.totalPlatform.queryTicketSellCounterPage({
                    body: {
                        ticketTemplateId: this.currentRow.ticketTemplateId,
                        pageNum: 1,
                        pageSize: 9999,
                    }
                }).then( res => {
                    let platformList = {};
                    this.platformList.forEach((el, index) => {
                        platformList[`platform${index}`] = res.list.filter(item => item.shopId == el.id).map(item => item.counterId)
                    });
                    this.platformForm.setFieldsValue(platformList)
                })
            },
            /**
             * @datePickerChange 上下架日期变更回调
             */
            datePickerChange(e, key) {
                let val = e.target.value;
                this[key] = val;
                if (val === 0) {
                    this.form.setFieldsValue({
                        [key === 'enableState' ? 'onShelvesTime' : 'offShelvesTime'] : null
                    });
                } else {
                    this.form.resetFields(key === 'enableState' ? 'onShelvesTime' : 'offShelvesTime');
                }
            },
            /**
             * @NoSellWeeksLimitAllChange 不可售卖日期全选回调
             */
            NoSellWeeksLimitAllChange(e) {
                let val = e.target.checked;
                if (val) {
                    this.NoSellWeeksLimitIndeterminate = false;
                    this.NoSellWeeksLimitCheckAll = true;
                    let NoSellWeeksLimit = this.weekData.map(i => i.value);
                    this.$nextTick(() => {
                        this.timeForm.setFieldsValue({ NoSellWeeksLimit });
                    })
                } else {
                    this.$nextTick(() => {
                        this.timeForm.setFieldsValue({ NoSellWeeksLimit: [] });
                    })
                    this.NoSellWeeksLimitIndeterminate = false;
                    this.NoSellWeeksLimitCheckAll = false;
                }
            },
            /**
             * @NoSellWeeksLimitChange 不可售卖日期选择回调
             */
            NoSellWeeksLimitChange(val) {
                if (val.length === 0) {
                    this.NoSellWeeksLimitIndeterminate = false;
                    this.NoSellWeeksLimitCheckAll = false;
                    return;
                }
                if (val.length < this.weekData.length) {
                    this.NoSellWeeksLimitIndeterminate = true;
                    this.NoSellWeeksLimitCheckAll = false;
                } else {
                    this.NoSellWeeksLimitIndeterminate = false;
                    this.NoSellWeeksLimitCheckAll = true;
                }
            },
            /**
             * @addExcludeDate 增加排除日期范围
             */
            addExcludeDate(addExcludeDate, index) {
                let key = this.$moment().valueOf();
                this.excludeDateList.push({
                    key: addExcludeDate ? (key + index) : key,
                    value: addExcludeDate ? addExcludeDate : null
                });
            },
            /**
             * @delExcludeDate 删除排除日期范围
             */
            delExcludeDate(index) {
                this.excludeDateList.splice(index, 1);
            },
            getTicketTime() {
                this.excludeDateList.length = 0;
                this.$api.totalPlatform.getTicketSellTimeInfo({
                    params: {
                        ticketTemplateId: this.currentRow.ticketTemplateId,
                    }
                }).then( res => {
                    if (res.noSellDatesLimit && res.noSellDatesLimit.ruleParam) {
                        let noSellDatesLimitList = JSON.parse(res.noSellDatesLimit.ruleParam);
                        noSellDatesLimitList.forEach((item, index) => {
                            let dates = item.split('~').map(i => this.$moment(i));
                            this.addExcludeDate(dates, index + 1);
                        });
                    }
                    this.timeForm.setFieldsValue({
                        NoSellWeeksLimit: Boolean(res.noSellWeeksLimit) ? JSON.parse(res.noSellWeeksLimit.ruleParam).map(Number) : undefined,
                        onShelvesTime: Boolean(res.onShelvesTime) ? this.$moment(res.onShelvesTime) : undefined,
                        offShelvesTime: Boolean(res.offShelvesTime) ? this.$moment(res.offShelvesTime) : undefined,
                        disableState: Boolean(res.offShelvesTime) ? 1 : 0,
                        enableState: Boolean(res.onShelvesTime) ? 1 : 0,
                    });
                    this.disableState = res.offShelvesTime ? 1 : 0;
                    this.enableState = res.onShelvesTime ? 1 : 0;
                })
            },
            changePlatform() {
                this.platformForm.validateFields((err, values) => {
                    if (err) return;
                    var counters = [];
                    this.platformList.forEach((el, index) => {
                        values[`platform${index}`] && values[`platform${index}`].forEach( item => {
                            let platform = el.platform.find($items => item == $items.id)
                            if (platform) {
                                counters.push({
                                    counterId: platform.id,
                                    counterName: platform.name,
                                    shopId: platform.shopId,
                                    shopName: platform.shopName,
                                })
                            }
                        })
                    });
                    this.$api.totalPlatform.batchAddSellCounter({
                        body: {
                            counters,
                            operateShopId: this.shopId,
                            ticketTemplateId: this.currentRow.ticketTemplateId,
                        }
                    }).then( res => {
                        this.$message.success("操作成功");
                        this.visiblePlatform = false;
                        this.getList();
                    })
                })
            },
            changeTime() {
                this.timeForm.validateFields((err, values) => {
                    if (err) return;
                    let noSellDatesLimit;
                    let noSellWeeksLimit;
                    values.onShelvesTime = values.onShelvesTime && values.enableState ? values.onShelvesTime.format('YYYY-MM-DD HH:mm:ss') : undefined;
                    values.offShelvesTime = values.offShelvesTime && values.disableState ? values.offShelvesTime.format('YYYY-MM-DD HH:mm:ss') : undefined;
                    //不可售卖星期限制规则
                    if (Boolean(values.NoSellWeeksLimit) && Boolean(values.NoSellWeeksLimit.length)) {
                        noSellWeeksLimit = {
                            limitParams: values.NoSellWeeksLimit,
                            ruleCode: 'NoSellWeeksLimit'
                        };
                    }
                    //不可售卖日期限制规则
                    if (Boolean(values.NoSellDatesLimit) && Boolean(values.NoSellDatesLimit.length)) {
                        let NoSellDatesLimit = values.NoSellDatesLimit.map(item => {
                            return (item[0].format('YYYY-MM-DD') + '~' + item[1].format('YYYY-MM-DD'));
                        });
                        noSellDatesLimit = {
                            limitParamSegments: NoSellDatesLimit,
                            ruleCode: 'NoSellDatesLimit'
                        }
                    }
                    this.$api.totalPlatform.setTicketSellTime({
                        body: {
                            noSellWeeksLimit,
                            noSellDatesLimit,
                            onShelvesTime: values.onShelvesTime,
                            offShelvesTime: values.offShelvesTime,
                            ticketTemplateId: this.currentRow.ticketTemplateId,
                        }
                    }).then( res => {
                        this.$message.success("操作成功");
                        this.visibleTime = false;
                    })
                })
            },
            changeNum() {
                this.reserveForm.validateFields((err, values) => {
                    if (err) return;
                    this.$api.totalPlatform.setTicketStock({
                        body: {
                            stockNum: values.type == 1 ? '999999999' : values.stockNum,
                            ticketTemplateId: this.currentRow.ticketTemplateId,
                        }
                    }).then( res => {
                        this.getList();
                        this.$message.success("操作成功");
                        this.visibleNum = false;
                    })
                })
            },
            openModel(type, row) {
                this.currentRow = row;
                switch (type) {
                    case 1:
                        this.visibleTime = true;
                        this.getTicketTime();
                        break;
                    case 2:
                        this.visiblePlatform = true;
                        this.getPlatform();
                        break;
                    case 3:
                        this.visibleNum = true;
                        setTimeout(() => {
                            this.reserveForm.setFieldsValue({
                                type: row.totalStockNum === 999999999 ? 1 : 2,
                                stockNum: row.totalStockNum === 999999999 ? undefined : row.totalStockNum
                            });
                        }, 300);
                        break;
                    default:
                        break;
                }
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset () {
                this.form.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey
                this.pagination.current = 1;
                setTimeout(() => {
                    this.getList();
                }, 400);
            },
            changeStateType() {
                this.$nextTick(() => {
                    this.autoChangeForm.validateFields()
                })
            },
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    values.isOnShelves = Number(this.noTitleKey);
                    this.tableLoading = true;
                    switch(values.sellPlatform) {
                        case 1:
                            values.isMiniSell = true;
                            break;
                        case 2:
                            values.isCounterSell = true;
                            break;
                        case 3:
                            values.isPointSell = true;
                            break;
                        case 4:
                            values.isThirdSell = true;
                            break;
                        default:
                            break;
                    }
                    delete values.sellPlatform;
                    this.$api.totalPlatform.ticketList({
                        body: {
                            ...values,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        }
                    }).then(res => {
                        this.tableLoading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    }).catch(err => {
                        this.tableLoading = false;

                    })
                });
            },
            // 系统票券获取
            getTicket(lineType, shopId) {
                this.$api.totalPlatform.getTotalTicketList({
                    body: {
                        sellShopId: lineType == 2 || lineType == 3 ? shopId : undefined,
                        isMiniSell: lineType == 1 ? true : undefined,
                        isCounterSell: lineType == 2 ? true : undefined,
                    }
                }).then(res => {
                    if (!res) return;
                    res.forEach( el => {
                        el.label = el.name;
                        el.value = el.ticketTemplateId;
                    });
                    this.ticketList = res || [];
                });
            },
            /**
             * @ticketState 票券上下架
             */
            ticketState(ticketTemplateId, state) {
                this.$api.totalPlatform.ticketState({
                    params: {
                        state: !state,
                        ticketTemplateId,
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList();
                })
            },
            /**
             * @ticketRemove 票券删除
             */
            ticketRemove(ticketTemplateId) {
                this.$api.totalPlatform.removeTicket({
                    params: {
                        ticketTemplateId
                    }
                }).then(res => {
                    this.$message.success('操作成功');
                    this.getList()
                })
            },
            toAddTicket(flag = true) {
                // 跳转至新增页
                flag ? this.$router.push({ name: "addTicket"}) : this.$refs.ticketPicker.visible = true;
            },
            confirmSelectTicket(ticket) {
                if (!ticket || !ticket.length) {
                    this.$message.warning("请先选择票券");
                    return;
                }
                let ticketTemplateId = ticket.map(el => el.ticketTemplateId);
                this.$router.push({ name: "addTicket", query: { ticketTemplateId ,isCopy: true}});
            },
            toUpdateTicket(ticketTemplateId) {
                // 跳转至编辑页
                this.$router.push({ name: "updateTicket", query: { ticketTemplateId }});
            },
            toDetailTicket(ticketTemplateId) {
                // 跳转至详情页
                this.$router.push({ name: "detailTicket", query: { ticketTemplateId }});
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    res.forEach(i => {
                        i.label = i.name;
                        i.value = i.id;
                    })
                    this.shopList = res;
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.reserveForm = this.$form.createForm(this);
            this.timeForm = this.$form.createForm(this);
            this.platformForm = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
            this.getShopList();
            this.getTicket();
        },
        watch: {
            '$route'(val) {
                val.name == 'ticket' && this.getList();
            }
        }
    };
</script>
<style lang="scss">
    .totalplatform-ticket-manage {
        .wrap-container-in {
            background-color: #fff;
            padding: 24px 32px;
            border-radius: 2px;
        }
        .action {
            a {
                white-space: nowrap;
            }
        }
    }
</style>
